// components/Dashboard/KPICard.jsx
import React from "react";
import { Text, Spinner } from "@fluentui/react-components";

export default function KPICard({
  title,
  value,
  subtitle,
  icon,
  gradient,
  loading,
  onClick,
  style = {},
}) {

  return (
    <div
      onClick={onClick}
      style={{
        background: gradient || "linear-gradient(135deg, #0052CC 0%, #0041B8 100%)",
        borderRadius: 16,
        padding: "24px",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        gap: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
        position: "relative",
        overflow: "hidden",
        minHeight: 140,
        cursor: onClick ? "pointer" : "default",
        transition: onClick ? "transform 0.12s, box-shadow 0.12s" : undefined,
        ...style,
      }}
      onMouseEnter={onClick ? (e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.2)"; } : undefined}
      onMouseLeave={onClick ? (e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.12)"; } : undefined}
    >
      {/* Background decoration */}
      <div
        style={{
          position: "absolute",
          right: -20,
          top: -20,
          width: 100,
          height: 100,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.08)",
        }}
      />
      <div
        style={{
          position: "absolute",
          right: 10,
          bottom: -30,
          width: 80,
          height: 80,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.05)",
        }}
      />

      {/* Header row */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Text
          style={{
            color: "rgba(255,255,255,0.82)",
            fontSize: 12,
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: 0.8,
          }}
        >
          {title}
        </Text>
        {icon && (
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "rgba(255,255,255,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 20,
            }}
          >
            {icon}
          </div>
        )}
      </div>

      {/* Value */}
      <div>
        {loading ? (
          <Spinner size="tiny" appearance="inverted" />
        ) : (
          <Text
            style={{
              fontSize: 32,
              fontWeight: 700,
              color: "#fff",
              lineHeight: 1.1,
              display: "block",
            }}
          >
            {value ?? "—"}
          </Text>
        )}
        {subtitle && (
          <Text style={{ color: "rgba(255,255,255,0.7)", fontSize: 12, marginTop: 2 }}>
            {subtitle}
          </Text>
        )}
      </div>


      {/* Drill-down hint */}
      {onClick && (
        <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: "auto" }}>
          <Text style={{ color: "rgba(255,255,255,0.55)", fontSize: 10, fontWeight: 500 }}>
            🔍 Click to view details
          </Text>
        </div>
      )}
    </div>
  );
}
